import { useEffect, useState } from 'react'

// local imports
import GymService from 'service/GymService'
import { GymListTypes, IFilteredGymGroupList, IFilteredGymSalonList, IFilteredGymTrainerList } from 'types/GymType'

export default function useGetGymServices(locationId: number, reservationDate: Date, resType: GymListTypes | null) {
  /* Local States */
  const [gymSalonList, setGymSalonList] = useState<IFilteredGymSalonList[] | []>([])
  const [groupLessonList, setGroupLessonList] = useState<IFilteredGymGroupList[] | []>([])
  const [trainerList, setTrainerList] = useState<IFilteredGymTrainerList[] | []>([])
  const [loading, setLoading] = useState(false)

  /* ######## Get GYM Services - Lists (Gym Salon, Group Lessons, Trainer List) ######## */
  useEffect(() => {
    if (!resType) return
    if (!!resType && resType === 'personal') {
      setLoading(true)
      GymService.getFilteredGymSalonList<IFilteredGymSalonList>({
        inventoryIdList: [],
        gymServiceId: 0,
        isEmployeeLocation: false,
        isIncludeNotActives: false,
        locationId: locationId,
        reservationDate: reservationDate,
      })
        .then((r) => setGymSalonList(r.data))
        .catch((err) => console.log(err))
        .finally(() => setLoading(false))
    } else if (resType === 'group') {
      setLoading(true)
      GymService.getFilteredGymGroupList<IFilteredGymGroupList>({
        gymGroupLessonId: 0,
        lessonTypeIdList: [],
        gymServiceId: 0,
        isEmployeeLocation: false,
        isIncludeNotActives: false,
        locationId: locationId,
        reservationDate: reservationDate,
      })
        .then((r) => setGroupLessonList(r.data))
        .catch((err) => console.log(err))
        .finally(() => setLoading(false))
    } else {
      GymService.getFilteredGymTrainerList<IFilteredGymTrainerList>({
        gymTrainerId: 0,
        gymTrainerServiceId: 0,
        trainerServiceTypeIdList: [],
        gymServiceId: 0,
        isEmployeeLocation: false,
        isIncludeNotActives: false,
        locationId: locationId,
        reservationDate: reservationDate,
      })
        .then((r) => setTrainerList(r.data))
        .catch((err) => console.log(err))
        .finally(() => setLoading(false))
    }
  }, [resType, locationId, reservationDate])

  return { gymSalonList, groupLessonList, trainerList, loading }
}
